import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

import "./graphCards.scss";

interface GraphCardProps {
  title: string;
  footer?: string;
  children?: React.ReactNode;
  customStyleChildren?: string;
  cardStyle?: string;
  cardHeaderStyle?: string;
  cardContentStyle?: string;
  cardFooterStyle?: string;
  isLoading?: boolean;
}

const GraphCard: React.FC<GraphCardProps> = ({
  title,
  footer,
  children,
  customStyleChildren,
  cardStyle = "",
  cardHeaderStyle = "",
  cardContentStyle = "",
  cardFooterStyle = "",
  isLoading = false,
}) => {
  return (
    <div className={`custom-graph-card border-style ${cardStyle}`}>
      <div
        className={`custom-graph-card-header ${cardHeaderStyle}`}
        data-tooltip={title}
      >
        <h4 className="custom-graph-card-title">{title}</h4>
      </div>
      {/* Render the loader if loading */}
      {isLoading ? (
        <div className="custom-graph-card-loader">
          <CircularProgress />
        </div>
      ) : (
        children && (
          <div
            className={
              customStyleChildren ||
              `custom-graph-card-content ${cardContentStyle}`
            }
          >
            {children}
          </div>
        )
      )}
      {footer && (
        <div className={`custom-graph-card-footer ${cardFooterStyle}`}>
          <small className="custom-graph-card-footer-text">{footer}</small>
        </div>
      )}
    </div>
  );
};

export default GraphCard;